module.exports = __webpack_public_path__ + "img/prize-1.103c14d5.png";